var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3.50098C1 3.22483 1.22386 3.00098 1.5 3.00098H10.5C10.7761 3.00098 11 3.22483 11 3.50098C11 3.77712 10.7761 4.00098 10.5 4.00098H1.5C1.22386 4.00098 1 3.77712 1 3.50098Z",
    fill: "#818181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64645 1.64742C8.84171 1.45216 9.15829 1.45216 9.35355 1.64742L10.8536 3.14742C11.0488 3.34269 11.0488 3.65927 10.8536 3.85453L9.35355 5.35453C9.15829 5.54979 8.84171 5.54979 8.64645 5.35453C8.45118 5.15927 8.45118 4.84269 8.64645 4.64742L9.79289 3.50098L8.64645 2.35453C8.45118 2.15927 8.45118 1.84269 8.64645 1.64742Z",
    fill: "#818181"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35355 6.64742C3.54882 6.84269 3.54882 7.15927 3.35355 7.35453L2.20711 8.50098L3.35355 9.64742C3.54882 9.84269 3.54882 10.1593 3.35355 10.3545C3.15829 10.5498 2.84171 10.5498 2.64645 10.3545L1.14645 8.85453C0.951184 8.65927 0.951184 8.34269 1.14645 8.14742L2.64645 6.64742C2.84171 6.45216 3.15829 6.45216 3.35355 6.64742Z",
    fill: "#818181"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8.50098C1 8.22483 1.22386 8.00098 1.5 8.00098H10.5C10.7761 8.00098 11 8.22483 11 8.50098C11 8.77712 10.7761 9.00098 10.5 9.00098H1.5C1.22386 9.00098 1 8.77712 1 8.50098Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundArrow);
export default __webpack_public_path__ + "static/media/round_arrow.1d82fdda3046a29d538aaab00f215a46.svg";
export { ForwardRef as ReactComponent };